import { useEffect } from "react";
import useNotificationsStore from "../stores/notifications";
import useUserStore from "../stores/user";

export const useNotifications = () => {
  const { user } = useUserStore();
  const {
    subscribeToNotifications,
    unsubscribeFromNotifications,
    fetchUnreadCount,
  } = useNotificationsStore();

  useEffect(() => {
    if (user?.id) {
      // Subscribe to real-time notifications
      subscribeToNotifications(user.id);

      // Fetch initial unread count efficiently
      fetchUnreadCount();

      // Cleanup subscription on unmount
      return () => {
        unsubscribeFromNotifications();
      };
    }
  }, [
    user?.id,
    subscribeToNotifications,
    unsubscribeFromNotifications,
    fetchUnreadCount,
  ]);

  return useNotificationsStore();
};
